export default "__VITE_ASSET__BpRsg1gk__"